import { render, staticRenderFns } from "./doItActionBox.vue?vue&type=template&id=f024f676&scoped=true"
import script from "./doItActionBox.vue?vue&type=script&lang=js"
export * from "./doItActionBox.vue?vue&type=script&lang=js"
import style0 from "./doItActionBox.vue?vue&type=style&index=0&id=f024f676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f024f676",
  null
  
)

export default component.exports